export function getFilterChangesForMutuallyExclusiveCheckboxes(
  selectedGroupName,
  selectedOption,
  checked,
  mutuallyExclusiveOptionNames
) {
  if (!checked || !mutuallyExclusiveOptionNames.has(selectedOption)) {
    return [];
  }
  return Array.from(mutuallyExclusiveOptionNames)
    .filter((optionToExclude) => optionToExclude !== selectedOption)
    .map((optionToExclude) => ({
      groupName: selectedGroupName,
      option: optionToExclude,
      value: false,
    }));
}

export function getFilterChangesForDropdownEnabledForSingleCheckbox(
  selectedGroupName,
  selectedOption,
  selectedValue,
  mutuallyExclusiveOptionNames,
  dropdownOptionName,
  checkboxOptionName
) {
  const changes = [];
  if (selectedOption === dropdownOptionName && selectedValue?.length) {
    changes.push(
      { groupName: selectedGroupName, option: checkboxOptionName, value: true },
      ...getFilterChangesForMutuallyExclusiveCheckboxes(
        selectedGroupName,
        checkboxOptionName,
        true,
        mutuallyExclusiveOptionNames
      )
    );
  }

  const checkOptionMutuallyExclusiveOptions = !mutuallyExclusiveOptionNames.has(
    checkboxOptionName
  )
    ? []
    : Array.from(mutuallyExclusiveOptionNames).filter(
        (opt) => opt !== checkboxOptionName
      );

  if (
    (selectedOption === checkboxOptionName && selectedValue === false) ||
    (checkOptionMutuallyExclusiveOptions.includes(selectedOption) &&
      selectedValue === true)
  ) {
    changes.push({
      groupName: selectedGroupName,
      option: dropdownOptionName,
      value: [],
    });
  }

  return changes;
}

export function applyFilterChanges(mapFilterParams, filterChanges) {
  return filterChanges.reduce(
    (newFilterParams, { groupName, option, value }) =>
      newFilterParams.setIn([groupName, option], value),
    mapFilterParams
  );
}
